// NEW: UI_REVAMP
export const BackspaceIcon = () => (
	<svg width='24' height='18' viewBox='0 0 24 18' xmlns='http://www.w3.org/2000/svg'>
		<path
			d='M22 0H7C6.3 0 5.8 0.3 5.4 0.9L0 9L5.4 17.1C5.8 17.6 6.3 18 7 18H22C23.1 18 24 17.1 24 16V2C24 0.9 23.1 0 22 0ZM19 12.6L17.6 14L14 10.4L10.4 14L9 12.6L12.6 9L9 5.4L10.4 4L14 7.6L17.6 4L19 5.4L15.4 9L19 12.6Z'
			fill='currentColor'
		/>
	</svg>
);
